import {
    ColumnWidthTableId,
    ColumnWidthColumnName,
    ColumnWidthWidth,
    ColumnWidthSetAction,
    ColumnWidthsRemoveAction
} from './types';
import { COLUMN_WIDTH_SET, COLUMN_WIDTHS_REMOVE } from './constants';

export function setColumnWidth(
    tableId: ColumnWidthTableId,
    columnName: ColumnWidthColumnName,
    width: ColumnWidthWidth
): ColumnWidthSetAction {
    return {
        type: COLUMN_WIDTH_SET,
        payload: {
            tableId,
            columnName,
            width
        }
    };
}

export function removeColumnWidths(
    tableId: ColumnWidthTableId
): ColumnWidthsRemoveAction {
    return {
        type: COLUMN_WIDTHS_REMOVE,
        payload: {
            tableId
        }
    };
}
